import React, { useState, useContext } from 'react';

import { AppStateContext } from '../AppStateContext';

import emailjs from 'emailjs-com';

import SecondButton from './button/SecondButton';

// IMPORT DATA
const ContactForm = () => {

    const { language, setLanguage } = useContext(AppStateContext);
    const [done, setDone] = useState(false)

    const translations = {
        tr: {
            contacttext1: 'İletişim Formu',
            contacttext2: 'Lütfen formu tamamen doldurduğunuzdan emin olun.',
            contacttext3: 'Ad',
            contacttext4: 'Soyad',
            contacttext5: 'Telefon Numarası',
            contacttext6: 'E-Posta Adresi',
            contacttext7: 'Tedavi Seçiniz',
            contacttext8: 'Bize iletmek istediğiniz bir mesajınız var mı?',
            contacttext9: 'Formu Gönder',
            treatments: ['Zirkonyum', 'E-max', 'Lamine Veneer', 'İmplant', 'Kök Kanal Tedavisi', 'Diş Çekimi', 'Ortodonti', 'Diş Beyazlatma', 'Diş Temizliği', 'Diş Dolgusu']
        },
        en: {
            contacttext1: 'Contact Form',
            contacttext2: 'Make sure you fill out the form completely.',
            contacttext3: 'Name',
            contacttext4: 'Surname',
            contacttext5: 'Phone Number',
            contacttext6: 'Mail Address',
            contacttext7: 'Select Your Treatment',
            contacttext8: 'Do You Have a Message For Us?',
            contacttext9: 'Send Form',
            treatments: ['Zirconium', 'E-max', 'Lamine Veneers', 'Implant', 'Root Canal', 'Tooth Extraction', 'Orthodontics', 'Dental Bleaching', 'Dental Scaling', 'Dental Filling']
        },
        it: {
            contacttext1: 'Modulo di Contatto',
            contacttext2: 'Assicurati di compilare il modulo completamente.',
            contacttext3: 'Nome',
            contacttext4: 'Cognome',
            contacttext5: 'Numero di Telefono',
            contacttext6: 'Indirizzo Email',
            contacttext7: 'Seleziona il Tuo Trattamento',
            contacttext8: 'Hai un Messaggio per Noi?',
            contacttext9: 'Invia Modulo',
            treatments: ['Zirconio', 'E-max', 'Lamine', 'Impianto', 'Devitalizzazione', "Estrazione del Dente", "Ortodonzia", 'Sbiancamento Dentale', 'Pulizia Dentale', 'Otturazione Dentale']
        },
    };

    const getText = (key) => {
        return translations[language][key] // Default to the provided key if translation is not found
    };

    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        phoneNumber: '',
        email: '',
        treatmentOptions: '',
        message: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        console.log(formData)
    };


    const EMAILJS_SERVICE_ID = 'service_drca4ol';
    const EMAILJS_TEMPLATE_ID = 'template_mr2x534';
    const EMAILJS_USER_ID = 'lRslydhOlt8DdroWn';

    const handleSendEmail = () => {
        // Check if all required fields are filled before sending the email
        if (formData.name && formData.surname && formData.treatmentOptions && formData.phoneNumber && formData.message && formData.email) {

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailRegex.test(formData.email)) {
                console.log('Invalid email format. Please enter a valid email address.');
                document.getElementById('email-input').style.borderColor = 'red';
                return;
            } else {
                document.getElementById('email-input').style.borderColor = '';
            }
            const formattedPhoneNumber = formData.phoneNumber.replace(/\s/g, '')

            if (formattedPhoneNumber.length <= 9) {
                console.log('Phone number must be 10 characters long.');
                console.log('Formatted Phone Number:', formattedPhoneNumber)
                document.getElementById('phone-input').style.borderColor = 'red';
                return;
            } else {
                document.getElementById('phone-input').style.borderColor = '';
            }

            const emailParams = {
                name: formData.name,
                surname: formData.surname,
                email: formData.email,
                treatmentOptions: formData.treatmentOptions,
                phoneNumber: formData.phoneNumber,
                message: formData.message,
            };

            emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, emailParams, EMAILJS_USER_ID)
                .then((response) => {
                    console.log('Email sent successfully!', response);
                    window.alert('Email sent successfully!')
                    setFormData({
                        name: '',
                        surname: '',
                        phoneNumber: '',
                        email: '',
                        treatmentOptions: '',
                        message: '',
                    })
                    setDone(true)
                    // You can show a success message or perform other actions here
                })
                .catch((error) => {
                    console.error('Error sending email:', error);
                    // Handle the error, show an error message, etc.
                });
        } else {
            // Handle the case when required fields are not filled
            window.alert('Lütfen teklifi göndermeden önce tüm zorunlu alanları doldurun.')
        }
    };

    return (
        <div className="p-5 md:p-10 py-10 bg-slate-50 h-full w-full rounded-2xl">
            <h2 style={{ fontFamily: 'Righteous' }} className="text-2xl md:text-4xl font-semibold mb-4 text-[#0F969C]">{getText('contacttext1')}</h2>
            <h2 className="text-lg md:text-xl mb-4">{getText('contacttext2')}</h2>
            <div className="space-y-4">
                <div className='flex flex-row gap-5'>
                    <input
                        type="text"
                        name="name"
                        placeholder={getText('contacttext3')}
                        value={formData.name}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border rounded-lg"
                    />
                    <input
                        type="text"
                        name="surname"
                        placeholder={getText('contacttext4')}
                        value={formData.surname}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border rounded-lg"
                    />
                </div>

                <div className='flex flex-row gap-5'>
                    <input
                        id="phone-input"
                        type="tel"
                        name="phoneNumber"
                        placeholder={getText('contacttext5')}
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border rounded-lg"
                    />
                    <input
                        id="email-input"
                        type="email"
                        name="email"
                        placeholder={getText('contacttext6')}
                        value={formData.email}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border rounded-lg"
                    />
                </div>
                <div className='p-4'></div>
                <select
                    name="treatmentOptions"
                    value={formData.treatmentOptions}
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border rounded-lg"
                >
                    <option value="">{getText('contacttext7')}</option>
                    {translations[language].treatments.map((treatment, index) => (
                        <option key={index} value={treatment}>
                            {treatment}
                        </option>
                    ))}
                </select>
                <textarea
                    name="message"
                    placeholder={getText('contacttext8')}
                    value={formData.message}
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border rounded-lg h-56"
                />
                <div onClick={() => handleSendEmail()} className='flex justify-end'>
                    <SecondButton text={getText('contacttext9')} />
                </div>
            </div>
        </div>
    );
};

export default ContactForm;
